import Aos from "aos";
import { StackedChart } from "../../components/charts";
import { _l } from "../../utils/_LangUtils";
import { FormatUtils } from "../../utils/_FormatUtils";
import { IntervalTimer } from "../../utils/_TimerUtils";
import { NumberUtils } from "../../utils/_NumberUtils";
import { fundDetails } from "../../actions/user";
require("./../../partials/supporters.js");


// require('./../../components/sliders/supporters');
let percent = 0.18;

const $range = $("input.form-range");
const fundChart = new StackedChart("#fund_chart").chart;

/**
 * change the current slide to given
 * @param {number} next_slide number of slide that you want
 */

function slide(next_slide) {
    $(".slide_indicator.active").removeClass("active");
    $(".slider_image.show, .slider_text.show").removeClass("show").fadeOut(200);

    $(`.slide_indicator[data-slide=${next_slide}]`).addClass("active");
    $(
        `.slider_image[data-slide=${next_slide}], .slider_text[data-slide=${next_slide}]`
    )
        .addClass("show")
        .fadeIn(200);

    slider_interval.reset();
}

/**
 *
 * @param {jQuery} range
 * @return {{labels: array, down: array, up: array}}
 */
function calculateChart(range) {
    const cols_count = 12;
    const val = range.val();

    const labels = [...Array(cols_count)].map((d, i) => i);

    const profit = Math.round(parseInt(val, 10) * 465 * (percent / 365));
    const sum = parseInt(val, 10) * 30;

    const profits = [...Array(cols_count)].map((d, i) => profit * (i + 1) * 30);
    const sums = [...Array(cols_count)].map((d, i) => sum * (i + 1));

    return {
        labels,
        profits,
        sums,
    };
}

const slides_count = $(".slide_indicator:last-child").data("slide");
let next_slide = 1;
let slider_interval = new IntervalTimer(() => {
    next_slide = next_slide < slides_count ? next_slide + 1 : 1;
    slide(next_slide);
}, 10000);


const htmlLang = $("html").attr("lang");
function updateChart() {
    let chart_data = calculateChart($range);
    fundChart.data = {
        labels: chart_data.labels,
        datasets: [
            {
                label: htmlLang === "en"? "Profit allocated to you in month" : _l("profit allocated to you per month"),
                data: chart_data.profits,
                backgroundColor: "#1BAD6A", // green
                borderColor: "transparent",
                borderRadius: Number.MAX_VALUE,
                barThickness: 6,
            },
            {
                label: htmlLang === "en"? "Total investment in month" : _l("total investment per month"),
                data: chart_data.sums,
                backgroundColor: "#a4dec3", // red
                borderColor: "transparent",
                borderRadius: Number.MAX_VALUE,
                barThickness: 6,
            },
        ],
    };
    fundChart.options.plugins.tooltip.callbacks = {
        title: (item) => {
            const index = item[0].label;
            const label = item[0].dataset.label;
            return (
                label.substring(0, label.length - 1) +
                " " +
                (htmlLang === "en"? +index+1: NumberUtils.toNth(+index + 1))
            );
        },
        label: (context) => {
            const amount =
                context.datasetIndex === 1 ?
                    context.formattedValue :
                    FormatUtils.number(context.raw / 30);
            return amount + (htmlLang === "en"? "Rials": "ریال");
        },
    };
    fundChart.update();
}

$(() => {
    Aos.init({
        once: true,
    });

    // $('#select-lang').on('click', (event)=>{
    //     event.preventDefault();

    //     const $this = $('#select-lang');

    //     $this.dropdown('toggle');
    // })

    // number format tags
    $(".number_format").text((index, text) =>
        text.trim().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );

    $("#landing_head_slider")
        .on("mouseover", () => {
            slider_interval.pause();
        })
        .on("mouseout", () => {
            slider_interval.resume();
        });
    // Header Slider
    $("#next_slide").on("click", () => {
        next_slide = next_slide < slides_count ? next_slide + 1 : 1;
        slide(next_slide);

        slider_interval.reset();
    });

    $("#prev_slide").on("click", () => {
        next_slide = next_slide > 1 ? next_slide - 1 : slides_count;
        slide(next_slide);

        slider_interval.reset();
    });

    // Range change

    // Chart
    fundDetails(2)
        .then((details) => {
            percent = +details.all_fund_details.pop().simple_yearly / 100;
        })
        .then(() => {
            updateChart();

            $(".volume_result_value").text(FormatUtils.number($range.val()));
            $(".month_volume_value").text(
                FormatUtils.number(+$range.val() * 30)
            );
            $(".day_volume_value").text(
                FormatUtils.number(
                    Math.round(+$range.val() * 465 * (percent / 365))
                )
            );

            $range.on("input change", () => {
                const val = $range.val();
                $(".volume_result_value").text(FormatUtils.number(val));
                $(".month_volume_value").text(FormatUtils.number(+val * 30));
                $(".day_volume_value").text(
                    FormatUtils.number(Math.round(+val * 465 * (percent / 365)))
                );

                updateChart();
            });

            $("span.increase").on("click", () => {
                const step = parseInt($range.attr("step"), 10);
                const max = parseInt($range.attr("max"), 10);
                const val = parseInt($range.val(), 10);
                if (val < max) {
                    $range.val(val + step).trigger("input");
                }
            });
            $("span.decrease").on("click", () => {
                const step = parseInt($range.attr("step"), 10);
                const min = parseInt($range.attr("min"), 10);
                const val = parseInt($range.val(), 10);
                if (val > min) {
                    $range.val(val - step).trigger("input");
                }
            });
        });

    const caro = $("#exp_messages").carousel();
    $("#exp_users").on("slide.bs.carousel", (event) => {
        const { to } = event;
        caro.carousel(+to);
    });

    $(".lisence_item").on("click", function(event) {
        event.stopPropagation();

        const $this = $(this);
        const $modal = $("#lisence_modal");

        const src = $this.find("img").data("src");
        $modal.find("img").attr("src", src);
        $modal.modal("show");
    });
});
